export default __webpack_public_path__ + "static/twitch-cover-photo-size-fcba52c2898c14bbdb082f4104876420.jpg";